export default __webpack_public_path__ + "static/media/mr_mrs_smith_background_s2.8c389654.jpg";